<template>
  <main class="marketing-email-edit-content">

    <loading v-if="loading"
             class="marketing-email-edit-content-loading" />

    <template v-if="item">
      <marketing-email-form-content v-model="content"
                                    :email="item"
                                    :type="editorType"
                                    :view-only="viewOnly"
                                    @config="openConfig"
                                    @submit="saveContent(false)" />

      <marketing-email-config-modal :showing.sync="showConfigModal"
                                    :item="item"
                                    :is-automation-flow="item.isAutomationFlow"
                                    @saved="onConfigSaved" />
    </template>

    <div v-if="isRawTextEditor"
         class="marketing-email-edit-content-actions">
      <button class="btn btn-outline btn-extra-round"
              type="button"
              @click="openTestModal">
        {{$t('message.marketingGenerics.message.testSubmission')}}
      </button>

      <button class="btn btn-primary btn-extra-round"
              type="submit"
              @click="onNextStep">
          {{$t('message.generics.message.advance')}}
      </button>
    </div>

    <marketing-email-test v-model="showingTestModal"
                          :item="item" />

  </main>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";
import MarketingEmailTest from "@components/modules/marketing/email/test/MarketingEmailTest";
import MarketingEmailFormContent from "@components/modules/marketing/email/form/content/MarketingEmailFormContent";
import MarketingEmailConfigModal from "@components/modules/marketing/email/config/modal/MarketingEmailConfigModal";
import EventBus from "@packages/event-bus/index";

export default {
  components: {
    MarketingEmailFormContent,
    MarketingEmailConfigModal,
    MarketingEmailTest,
    Loading,
  },

  props: {},

  computed: {
    isRawTextEditor() {
      return this.item && this.item.editorType === "RAW_TEXT";
    },
    viewOnly() {
      return this.$store.state.marketing.email.edit.viewOnly;
    },
  },

  watch: {},

  data() {
    return {
      content: {
        htmlContent: undefined,
        cssStyle: undefined,
      },
      showConfigModal: false,
      item: undefined,
      editorType: undefined,
      showingTestModal: false,
      loading: false,
    };
  },

  methods: {
    openTestModal() {
      this.showingTestModal = true;
    },
    async advanceStep() {
      this.$store.commit("SET_EMAIL_EDIT_STEP", 2);

      if (this.item.isAutomationFlow) {
        this.$router.push({
          path: `/marketing/email/editar/${this.item.id}/verificacao`,
        });
      } else {
        this.$router.push({
          path: `/marketing/email/editar/${this.item.id}/destinatarios`,
        });
      }
    },
    openConfig() {
      this.showConfigModal = true;
    },
    onConfigSaved(updatedEmail) {
      this.item = updatedEmail;

      this.closeConfigModal();
    },
    closeConfigModal() {
      this.showConfigModal = false;
    },
    openConfigModal() {
      this.showConfigModal = true;
    },
    async saveContent(validateSender = false) {
      this.$store.commit("SET_EMAIL_CONTENT_SAVING", true);

      const updatedEmail = await this.$api.marketing.email.message.edit({
        emailId: this.item.id,
        validateSender,
        data: {
          ...this.item,
          rawContent: this.content.htmlContent,
          cssStyle: this.content.cssStyle,
          editorType: this.editorType,
        },
      });

      this.item = updatedEmail;

      this.$store.commit("SET_EMAIL_CONTENT_SAVING", false);
    },
    async onNextStep() {
      if (!this.viewOnly) {
        await this.saveContent(true);
      }
      this.advanceStep();
    },
    async fetchEmail() {
      this.loading = true;

      const emailId = this.$route.params.emailId;

      const email = await this.$api.marketing.email.message.get({
        emailId,
      });

      this.item = email;

      this.content = {
        htmlContent: email.rawContent,
        cssStyle: email.cssStyle,
      };

      this.editorType = email.editorType;

      this.$store.commit("SET_EMAIL_EDIT_EDITOR_TYPE", email.editorType);
      this.$store.commit("EMAIL_EDIT_SET_AUTOMATION", email.isAutomationFlow);

      this.loading = false;
    },
    setIsViewOnly() {
      const isViewOnly = this.$route.query.viewOnly === "1";

      this.$store.commit("SET_EMAIL_EDIT_IS_VIEW", isViewOnly);
    },
  },

  created() {
    this.$store.commit("SET_EMAIL_EDIT_STEP", 1);

    this.setIsViewOnly();

    this.fetchEmail();

    EventBus.$on("EMAIL_EDIT_NEXT_STEP", this.onNextStep);
  },

  beforeDestroy() {
    EventBus.$off("EMAIL_EDIT_NEXT_STEP", this.onNextStep);
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-edit-content {
  .marketing-email-edit-content-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }

  .marketing-email-edit-content-actions {
    display: flex;
    justify-content: center;
    gap: 30px;
  }
}
</style>

